import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=19fcdd08&scoped=true&"
import script from "./BaseTooltip.vue?vue&type=script&lang=ts&"
export * from "./BaseTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTooltip.vue?vue&type=style&index=0&id=19fcdd08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fcdd08",
  null
  
)

export default component.exports